import { useAppStore } from "@/stores/modules/app";

/**
 * 路由跳转loading
 */
export const usePageLoading = () => {
  const loadStart = () => {
    const appStore = useAppStore();

    appStore.setPageLoading(true);
  };

  const loadDone = () => {
    const appStore = useAppStore();

    appStore.setPageLoading(false);
  };

  return {
    loadStart,
    loadDone,
  };
};
